import React from 'react';
import { CheckCircle } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
export function ComparisonSection() {
  const rows = [{
    label: 'Cost',
    agency: '€2,000+',
    diy: '€0-30/mo',
    us: '€249 one-time'
  }, {
    label: 'Speed',
    agency: '4-8 weeks',
    diy: 'Days-weeks',
    us: 'Fast delivery'
  }, {
    label: 'Ownership',
    agency: 'Sometimes',
    diy: 'Yes',
    us: 'Yes — yours'
  }, {
    label: 'Editing',
    agency: 'Pay per change',
    diy: 'You do it',
    us: 'AI-assisted (100/mo)'
  }, {
    label: 'Support',
    agency: 'Variable',
    diy: 'Forums',
    us: 'Direct WhatsApp'
  }, {
    label: 'Conversion Focus',
    agency: 'Rarely',
    diy: 'No',
    us: 'Yes — built-in'
  }];
  return <section id="comparison" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-97">
      <div className="max-w-6xl mx-auto" data-id="element-98">
        <div className="text-center mb-12 reveal" data-id="element-99">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-100">
            How Much Does Website Design Cost in Ireland?
          </h2>
          <p className="text-white/70 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-101">
            Most web design agencies in Ireland charge between €3,000 and €5,000
            for a basic business website. Freelancers typically start at
            €1,000+. Our €249 launch package delivers the same professional
            quality at a fraction of the cost, because we use efficient
            AI-powered tools to build faster.
          </p>
          <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-102">
            {['No €2,000+ fees', 'No monthly lock-in', 'Edit anytime with AI', 'Clear process + revisions'].map((item, i) => <div key={i} className="flex items-center space-x-2 bg-white/[0.06] px-4 py-2 rounded-full" data-id="element-103">
                <CheckCircle className="w-4 h-4 text-[#c9a84c]" data-id="element-104" />
                <span className="text-sm text-white/90" data-id="element-105">{item}</span>
              </div>)}
          </div>
        </div>

        <div className="overflow-x-auto reveal" data-id="element-106">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-107">
            <thead data-id="element-108">
              <tr data-id="element-109">
                <th className="p-4 text-white/50 font-medium text-sm uppercase tracking-wider w-1/4" data-id="element-110">
                  Feature
                </th>
                <th className="p-4 text-white/60 font-medium text-lg w-1/4" data-id="element-111">
                  Agencies
                </th>
                <th className="p-4 text-white/60 font-medium text-lg w-1/4" data-id="element-112">
                  DIY Builders
                </th>
                <th className="p-4 text-[#c9a84c] font-bold text-xl w-1/4 rounded-t-xl border-t border-l border-r border-[#c9a84c]/20" style={{
                backgroundColor: 'rgba(201, 168, 76, 0.08)'
              }} data-id="element-113">
                  This Package
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/[0.06]" data-id="element-114">
              {rows.map((row, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-white/[0.02]' : ''} data-id="element-115">
                  <td className="p-4 text-white/80 font-medium" data-id="element-116">{row.label}</td>
                  <td className="p-4 text-white/50" data-id="element-117">{row.agency}</td>
                  <td className="p-4 text-white/50" data-id="element-118">{row.diy}</td>
                  <td className="p-4 text-white font-bold border-l border-r border-[#c9a84c]/20" style={{
                backgroundColor: 'rgba(201, 168, 76, 0.08)'
              }} data-id="element-119">
                    {row.us}
                  </td>
                </tr>)}
              <tr data-id="element-120">
                <td className="p-4" data-id="element-121"></td>
                <td className="p-4" data-id="element-122"></td>
                <td className="p-4" data-id="element-123"></td>
                <td className="p-4 rounded-b-xl border-b border-l border-r border-[#c9a84c]/20" style={{
                backgroundColor: 'rgba(201, 168, 76, 0.08)'
              }} data-id="element-124"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <SectionDivider data-id="element-125" />
    </section>;
}